const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import styled from 'astroturf/react'

import { useI18n } from 'locales'
import Checkbox from 'components/form/checkbox'
import _LabelText from "external_communication_consent-LabelText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/fields/external_communication_consent.js?styleId=LabelText";


const LabelText = /*#__PURE__*/styled('span', null, {
  displayName: "LabelText",
  styles: _LabelText,
  attrs: props => ({
    ...props,
    children: useI18n().i18n.t('booking.invitee.external_communication_consent.label')
  })
})

export const ExternalCommunicationConsent = ({ value, onChange }) => (
  <Checkbox
    data-id="consent_checkbox_label"
    label={<LabelText />}
    checked={value}
    onChange={onChange}
    name="external_communication_consent"
  />
)
